import { render, staticRenderFns } from "./ClassModeler.vue?vue&type=template&id=5b453cfb&xmlns%3Av-on=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./ClassModeler.vue?vue&type=script&lang=js&"
export * from "./ClassModeler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports